import { create } from 'zustand';
import { InteractiveSplineToolEnum } from '@modules/three/common/curve/interactiveSpline/InteractiveSplineToolEnum';
import { TransformToolEnum } from '@modules/three/common/transformMesh/TransformToolEnum';
import { SculptOpts } from '@/thirdPartyLibraries/three-mesh-halfedge/src/operations/sculpt';
import { toolManager } from '../tools/ToolManager';

export interface ThreeInteractionState {
  pointAdding: boolean;
  setPointAdding: (pointClicker: boolean) => void;

  // Invalidation tick for anchor add/remove to trigger UI updates
  anchorTick: number;
  bumpAnchorTick: () => void;

  editableLineTool: InteractiveSplineToolEnum;
  setEditableLineTool: (editableLineTool: InteractiveSplineToolEnum) => void;

  transformTool: TransformToolEnum;
  setTransformTool: (transformTool: TransformToolEnum) => void;

  activeToolName: string | null;
  setActiveTool: (name: string | null) => void;
  sculptMode: SculptOpts | null;
  setSculptMode: (s: SculptOpts) => void;

}

export const threeInteractionStore = create<ThreeInteractionState>((set) => ({
  pointAdding: false,
  setPointAdding: (pointClicker) => set({ pointAdding: pointClicker }),

  anchorTick: 0,
  bumpAnchorTick: () => set((s) => ({ anchorTick: s.anchorTick + 1 })),

  editableLineTool: null!,
  setEditableLineTool: (editableLineTool) => set({ editableLineTool }),

  transformTool: TransformToolEnum.TRANSLATE,
  setTransformTool: (transformTool) => set({ transformTool }),

  activeToolName: null,
  setActiveTool: (name) => { toolManager.setActive(name); set({ activeToolName: name }); },
  sculptMode: null,
  setSculptMode: (s) => set({ sculptMode: s }),
}));
